<template>
  <path pid="0" d="M17 9H7.41l3.3-3.29a1 1 0 10-1.42-1.42l-5 5-.09.11a.35.35 0 000 .08V9.65a.25.25 0 00-.2.15.13.13 0 010 .06V10a.76.76 0 000 .15.25.25 0 000 .07V10.39a.35.35 0 000 .08l.07.08 5 5a1 1 0 001.42-1.42L7.41 11H17a3 3 0 013 3v7a1 1 0 002 0v-7.22A5 5 0 0017 9z"/><path pid="1" d="M6.76 10.85v-.07a.15.15 0 000 .07z"/>
</template>
